import { pluralize } from 'utils/string';

export const MAX_LICENSES_ACCOUNT = 32000;

export const LICENSE_ACTION_LABELS = {
  ASSIGN: 'Assign License',
  REMOVE: 'Remove License',
} as const;

export const LICENSES_UPDATED = 'Licenses updated';
export const LICENSES_UPDATE_FAILED = 'Licenses couldn’t be updated';
export const LICENSES_NO_LONGER_CHANGEABLE =
  'Licenses couldn’t be updated: you can no longer change the selected users’ licenses';

export const seatsAvailable = (count: number | string): string => `${count} available`;

export const NO_TRAINING_LICENSES_BANNER = {
  TITLE: 'No training licenses available',
  BODY: 'You can still invite users without a license. However, they will not have access to training.',
  BUTTON: 'Contact us about licenses',
} as const;

export const NO_TRAINING_LICENSES_TOOLTIP = 'No training licenses available';

export const LICENSE_UPDATED = 'License updated';
export const LICENSE_UPDATE_FAILED = 'License couldn’t be updated';

export const LICENSE_CHANGES = {
  ASSIGNED: 'assigned',
  REMOVED: 'removed',
} as const;

export const licenseChange = (assign: boolean): string =>
  assign ? LICENSE_CHANGES.ASSIGNED : LICENSE_CHANGES.REMOVED;

export const trainingLicenseChanged = (assign: boolean): string =>
  `Training license ${licenseChange(assign)}`;

export const trainingLicenseChangeFailed = (assign: boolean): string =>
  `Training license couldn’t be ${licenseChange(assign)}`;

export const manageLicensesLabel = (selected: number): string =>
  `Manage license${selected > 1 ? 's' : ''}`;

export const manageInvitationLicensesTitle = (selected: number): string =>
  `Manage Invitation${selected > 1 ? 's' : ''} Licenses`;

export const manageInvitationLicensesDescription = (selected: number): string =>
  `What would you like to change for the ${pluralize(selected, 'selected invitation')}?`;

// Appended to a confirm message, so it starts with a space.
export const lockedLicensesNote = (locked: number): string =>
  locked
    ? ` ${pluralize(locked, 'selected user')} ${
        locked > 1 ? 'keep' : 'keeps'
      } their license: you can't change the account owner's or another team manager's.`
    : '';

export const lockedUnlicensedNote = (locked: number): string =>
  locked
    ? ` ${pluralize(locked, 'selected user')} ${
        locked > 1 ? "don't" : "doesn't"
      } get a license: you can't change the account owner's or another team manager's.`
    : '';
